module.exports = __webpack_public_path__ + "static/c5t-e3edfa0843e33fbbc7ceeae931045cb3.png";